import Axios from "../../../../api/axios/Axios";

export const getCreatorChannelVideos = (
  username,
  { limit = 12, offset = 0 } = {},
  signal,
) => {
  const creatorUsername = String(username || "").trim();

  if (!creatorUsername) {
    return Promise.reject(new Error("Creator username is required."));
  }

  return Axios.get(
    `/api/channels/${encodeURIComponent(creatorUsername)}/videos`,
    {
      params: {
        limit,
        offset,
      },
      signal,
    },
  );
};
